import { Card, Col, Flex, Row, Skeleton } from 'antd';
import React from 'react';
import BasicDivider from '../Divider/BasicDivider';

const CaseViewLoader = () => {
  return (
    <div className="pt-4">
      <Flex justify="space-between">
        <Skeleton.Input size="small"></Skeleton.Input>
        <Skeleton.Input size="small"></Skeleton.Input>
        <Skeleton.Input size="small"></Skeleton.Input>
      </Flex>
      <BasicDivider />
      <Row gutter={[16, 16]} className="mt-3">
        <Col sm={24} md={12}>
          <Card>
            <Skeleton />
            <Skeleton />
          </Card>
        </Col>
        <Col sm={24} md={12}>
          <Card>
            <Skeleton />
            <Skeleton />
          </Card>
        </Col>
        <Col sm={24} md={12}>
          <Card>
            <Skeleton />
            <Skeleton />
          </Card>
        </Col>
        <Col sm={24} md={12}>
          <Card>
            <Skeleton />
            <Skeleton />
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default CaseViewLoader;
